import type { PersonaWithHubPersonaId, PersonType, Searchable } from './hubPersona';
import type { UnifiedGroupAccessType } from '../../../service';

interface UnifiedGroupBasicProperties extends PersonaWithHubPersonaId, Searchable {
    readonly personaId: string;
    readonly emailAddress: string;
    readonly externalDirectoryObjectId: string;
    readonly displayName: string;
}

// Represents a Group that hasn't entirely loaded, e.g. a RecipientCache result
export interface UnifiedGroupBasicData extends UnifiedGroupBasicProperties {
    readonly type: PersonType.GroupBasicData;
}

export enum UnifiedGroupRestoreStatus {
    NONE,
    SUCCESSFUL,
    FAILED,
    EXO_FAILED,
    UNRESTORABLE,
    AAD_FAILED,
    RECENTLY_DELETED_FAILED,
}

export const enum UnifiedGroupExportStatus {
    None,
    NotPresent,
    InProgress,
    Completed,
    Failed,
}

export interface UnifiedGroup extends UnifiedGroupBasicProperties {
    readonly type: PersonType.Group;
    readonly accessType: UnifiedGroupAccessType;
    readonly description: string;
    readonly memberCount: number;
    readonly ownerCount: number;
    readonly pendingMembershipRequests: number;
    readonly isMember: boolean;
    readonly isOwner: boolean;
    readonly isFavorite: boolean;
    readonly isFollowed: boolean;
    readonly isExpiring: boolean;
    readonly expiryDateTime: Date;
    readonly lastVisitedTime: Date;
    readonly whenSoftDeletedTime?: Date;
    readonly joinedDateTime: Date;
    readonly isLoading: boolean;
    readonly isJoinRequestPendingApproval: boolean;
    readonly joinGroupUrl: string;
    readonly isMembershipDynamic: boolean;
    readonly allowAddGuests: boolean;
    readonly restoreStatus: UnifiedGroupRestoreStatus;
    readonly isSubscriptionEnabled: boolean;
    readonly mailboxGuid: string;
    readonly externalDirectoryOrganizationId: string;
    readonly exportStatus: UnifiedGroupExportStatus;
    readonly exportDownloadLink: string;
    readonly routingKey: string;
    readonly groupKind: number;
    readonly addMembersForFamilyUrl: string;
    readonly leaveGroupForFamilyUrl: string;
    readonly mailboxCultureName: string;
    readonly autoSubscribeNewMembers: boolean;
    readonly allowExternalSenders: boolean;
    readonly allowExportGroup: boolean;
}
